import { Input } from 'antd'

const { Search } = Input

interface SearchBlockProps {
  placeholder: string
  onSearch: (value: string) => void
}

export const SearchBlock = ({ placeholder, onSearch }: SearchBlockProps) => {
  return (
    <div className="d-flex flex-md-row flex-column align-items-md-center align-items-end w-100 mb-3">
      <Search
        className="mb-2 mb-md-0 w-100 w-md-auto"
        onChange={(e) => onSearch(e.target.value)}
        placeholder={placeholder}
        size="small"
      ></Search>
    </div>
  )
}
